import '../../styles/sections/section-two-col-complex.scss'
import {register} from '@shopify/theme-sections'

function showTabs(event)  {
    const eventTarget = event.currentTarget

    document.querySelectorAll(`.tabordion-label.active`).forEach((active_label) => {
        active_label.classList.remove(`active`)
    })
    document.querySelectorAll(`article.active`).forEach((active_article) => {
        active_article.classList.remove(`active`)
    })
    const articleTarget = eventTarget.dataset.articleId
    document.querySelectorAll(`[data-article-id=${articleTarget}]`).forEach((element) => {
        element.classList.add(`active`)
    })
}

export default register(`section-two-col-complex`, {
    onLoad() {
        const labels = document.querySelectorAll(`.tabordion-label`)
        const canMouseOver = window.matchMedia(`(pointer: fine)`).matches
        labels.forEach(label => {

            if (canMouseOver) {
                label.addEventListener(`mouseover`, showTabs)
            } else {
                label.addEventListener(`click`, (event) => {
                    showTabs(event)
                    if (event.currentTarget.id.includes(`col-label`)) {

                        let articleId = event.currentTarget.dataset.articleId

                        let article = document.getElementById(`row-${articleId}`)
                        let target = document.documentElement.scrollTop + article.getBoundingClientRect().top
                        if (target < document.documentElement.scrollTop - 190) {
                            window.scrollTo(0, target)
                        }
                    }
                })
            }
        })
    },

    onUnload() {
    },
})